import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals';
import { createStore, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { cartReducer } from './store/reducers/cartReducer';
// import { checkoutReducer } from './store/reducers/checkoutReducer';
import { BrowserRouter as Router, Switch, Route, useLocation } from 'react-router-dom';
import { history } from './common/history';
import '@algolia/autocomplete-theme-classic';

const store = createStore(cartReducer);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <div className="custom-wrapper-body">
        <Router history={history}>
          <App />
        </Router>
      </div>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
